export class VerticalMoving {
  constructor(rocket) {
    this.rocket = rocket
    this.verticalElapse = 0
  }
  resetVerticalElapse = () => (this.verticalElapse = 0)
  verticalMovingUpdater = (delta) => {
    this.verticalElapse += delta
    this.rocket.y = 235 + Math.sin(this.verticalElapse / 4) * 2
  }
  vertical = (ticker) => {
    ticker.remove(this.verticalMovingUpdater)
    ticker.add(this.verticalMovingUpdater)
  }
}
